import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { ru } from './locales/ru';
import { en } from './locales/en';

/**
 * i18next: ru (default) + en. Язык детектится из localStorage → navigator,
 * ресурсы заинлайнены (scaffold; позже можно вынести в http-backend).
 */
export function initI18n(): typeof i18n {
  if (!i18n.isInitialized) {
    void i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources: {
          ru: { translation: ru },
          en: { translation: en },
        },
        fallbackLng: 'ru',
        supportedLngs: ['ru', 'en'],
        interpolation: { escapeValue: false },
        detection: {
          order: ['localStorage', 'navigator'],
          caches: ['localStorage'],
        },
      });
  }
  return i18n;
}

export default i18n;
